import { isUSA } from "../../../constants/env";

export const DEFAULT_CUSTOM_LOGO_TEXT = isUSA ? "eShop Booster" : "Overenyweb.cz";